import React, { useState, useEffect } from "react";
import {
  Modal,
  Select,
  Typography,
  Row,
  Col,
  Flex,
} from "antd";
import axiosInstance from "utilities/axios";
const { Option } = Select;
const { Text } = Typography;

const FilterModal = ({ filters, setFilters, open, onClose }) => {
  const [regionOptions, setRegionOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [credentialOptions, setCredentialOptions] = useState([]);
  // const [vendorOptions, setVendorOptions] = useState([]);

  useEffect(() => {
    axiosInstance.get("/divisions").then((response) => {
      setDivisionOptions(response.data);
    });

    axiosInstance.get("/credentials/types").then((response) => {
      setCredentialOptions(response.data);
    });

    // axiosInstance.get("/vendors").then((response) => {
    //   setVendorOptions(response.data);
    // });
  }, []);

  useEffect(() => {
    if (filters.division.length > 0) {
      axiosInstance
        .get("/regions", { params: { division: filters.division } })
        .then((response) => {
          setRegionOptions(response.data);
          setFilters((prevFilters) => ({
            ...prevFilters,
            region: prevFilters.region.filter((value) =>
              response.data.map((region) => region.regionCode).includes(value)
            ),
          }));
        });
    } else {
      axiosInstance.get("/regions").then((response) => {
        setRegionOptions(response.data);
        setFilters((prevFilters) => ({
          ...prevFilters,
          region: prevFilters.region.filter((value) =>
            response.data.map((region) => region.regionCode).includes(value)
          ),
        }));
      });
    }
  }, [setFilters, filters.division]);

  return (
    <Modal
      title="Filter Options"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Row gutter={8} wrap={true}>
        <Col span={12}>
          <Flex vertical>
            <Text>Credential Type</Text>
            <Select
              mode="multiple"
              showSearch
              placeholder="Select Credential Type"
              value={filters.credentialType}
              onChange={(value) => 
                setFilters((prev) => ({ ...prev, credentialType: value }))
              }
            >
              {credentialOptions.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.typeName}
                </Option>
              ))}
            </Select>
          </Flex>
        </Col>
        <Col span={12}>
          <Flex vertical>
            <Text>Region</Text>
            <Select
              mode="multiple"
              showSearch
              placeholder="Select Region"
              value={filters.region}
              onChange={(value) =>
                setFilters((prev) => ({ ...prev, region: value }))
              }
            >
              {regionOptions.map((option) => (
                <Option key={option.regionCode} value={option.regionCode}>
                  {option.regionName} - {option.regionCode}
                </Option>
              ))}
            </Select>
          </Flex>
        </Col>
        <Col span={12}>
          <Flex vertical>
            <Text>Division</Text>
            <Select
              mode="multiple"
              placeholder="Select Division"
              value={filters.division}
              onChange={(value) =>
                setFilters((prev) => ({ ...prev, division: value }))
              }
            >
              {divisionOptions.map((option) => (
                <Option key={option.divisionCode} value={option.divisionCode}>
                  {option.divisionName}
                </Option>
              ))}
            </Select>
          </Flex>
        </Col>
        {/* <Col span={12}>
          <Flex vertical>
            <Text>Vendor</Text>
            <Select
              mode="multiple"
              placeholder="Select Vendor"
              value={filters.vendor}
              onChange={(value) =>
                setFilters((prev) => ({ ...prev, vendor: value }))
              }
            >
              {vendorOptions.map((option) => (
                <Option key={option.vendorId} value={option.vendorId}>
                  {option.vendorName}
                </Option>
              ))}
            </Select>
          </Flex>
        </Col> */}
      </Row>
    </Modal>
  );
};

export default FilterModal;